import Venue from 'types/models/Venue';
import { AgeRangeConfig, Splash } from 'types/models/Splash';
import axiosInstance from './axios';
import Order, { OrderDetailItem } from 'types/models/Order';
//import AuthData from 'types/models/AuthData';
//import User from 'types/models/User';


export const requestInvoice = async (body: any): Promise<any> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: `/orders/request-invoice`,
      data: body
    });
    return data;
  } catch (error: any) {
    return null;
  }
};

export const getOrder = async (orderId: number): Promise<Order | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'GET',
      url: `/orders/${orderId}`
    });
    return parseOrder(data);
  } catch (error: any) {
    console.log(error);
    return null;
  }
};

export const parseOrder = (order: any): Order => {
  return {
    id: order.id,
    commerce: {
      id: order.commerce.id,
      allowBilling: Boolean(order.commerce.allow_billing),
      globalsisBillingConfig: order.commerce.globalsis_billing_config ? {
        id: order.commerce.globalsis_billing_config.id,
        fiscalIdentificationNumber: order.commerce.globalsis_billing_config.fiscal_identification_number,
        puntoVentaNumber: order.commerce.globalsis_billing_config.numero_punto_venta,
        socialReason: order.commerce.globalsis_billing_config.social_reason,
        username: order.commerce.globalsis_billing_config.username,
        encryptedPassword: order.commerce.globalsis_billing_config.encryptedPassword,
      } : null
    },
    orderDetail: parseOrderDetail(order.order_detail),
    statusId: order.order_status_id,
    createdAt: order.created_at,
    totalAmount: parseFloat(order.total_amount),
    invoiceProcessId: order.invoice_process_id,
    invoiceEmail: order.invoice_email
  };
};

const parseOrderDetail = (data: any[]): OrderDetailItem[] => {
  return data.map(parseOrderDetailItem);
};

const parseOrderDetailItem = (data: any): OrderDetailItem => {
  return {
    id: data.id,
    productName: data.product.name,
    price: parseFloat(data.price),
    quantity: data.quantity
  };
};